import { menuToggleClass, closeAllMenus, menuExpandedAccessibility, menuClickOutSide, helperToggleMenuState } from './manager'

// Submenus (Top e Main) - Inclui classe no body e no item clicado
export const effectToggleSubMenu = (el, classRef, classToggle) => {
  const getParentElement = el.target.closest(classRef)
  const toggleEvent = getParentElement.classList.contains('mdn-isActive') ? 'remove' : 'add'

  closeAllMenus()
  menuExpandedAccessibility(el.target, toggleEvent)
  menuNotifiedLockScroll(getParentElement, toggleEvent)
  menuToggleClass('body', toggleEvent, classToggle)
  menuToggleClass(getParentElement, toggleEvent, 'mdn-isActive')
  menuClickOutSide(toggleEvent, helperToggleMenuState)
}

export const menuNotifiedLockScroll = (parentElement, toggleEvent) => {
  const isNotified = parentElement.classList.contains('mdn-Menu-list-item-notification')

  isNotified && menuToggleClass('body', toggleEvent, 'mdn-Menu-notified-isActive')
}

// MENU TOPO - CLICKS GENÉRICOS (Busca e Bandeiras)
export const effectToggleTopSubMenu = (el) => {
  effectToggleSubMenu(el, '.mdn-Menu-top-list-item', 'mdn-Menu-top-isActive')
}

// MENU TOPO - SEGMENTOS PF E PJ (somente Mobile)
export const effectToggleMenuTopSegment = (el) => {
  effectToggleSubMenu(el, '.mdn-Menu-top-list', 'mdn-Menu-top-isActive')
}

// MENU PRINCIPAL - CLICKS NOS ITENS DE MENU
export const effectToggleSubMenuMainMenu = (el) => {
  effectToggleSubMenu(el, '.mdn-Menu-list-item', 'mdn-Menu-main-isActive')
}

// MENU HAMBURGER - CLICKS GENÉRICOS (somente Mobile)
export const effectToggleSubMenuHamburger = (el) => {
  effectToggleSubMenu(el, '.mdn-Menu-content-left', 'mdn-Menu-main-isActive')
}

// SUBMENUS - Insere ou retira classes, verifica se usuário ainda está dentro do Submenu, qual é o tipo de menu correto
export const effectOpenSubMenuMobile = (el) => {
  const isHamburger = el.target.closest('.mdn-Menu-subMenu-list-item')
  const isSubMenu = el.target.closest('.mdn-Menu-list-item')
  const getParentElement = isHamburger ? isHamburger : isSubMenu
  const isMdnRightMenu =  el.target.closest('.mdn-Menu-content-right')

  if(isMdnRightMenu) {
    effectToggleSubMenuMainMenu(el)
  }
  else {
    menuToggleClass('body', 'add', 'mdn-Menu-subMenu-isActive')
    menuToggleClass(getParentElement, 'add', 'mdn-isActive')
  }
}

export const effectBackSubMenuMobile = (el) => {
  const getParentElement = el.target.closest('.mdn-isActive')

  menuToggleClass(getParentElement, 'remove', 'mdn-isActive')
}

export const effectToggleSubMenuSearch = (el) => {
  const bodyElement = document.querySelector('body')
  const isSearchItem = el.target.closest('.mdn-Menu-top-list-item-search')
  const listMenuSearch = document.querySelector('.mdn-Menu-top-list-item-search')

  if(!isSearchItem) {
    menuToggleClass(listMenuSearch, 'remove', 'mdn-isActive')
    menuToggleClass(bodyElement, 'remove', 'mdn-Menu-top-isActive')
  }
}

export const effectSearchSubMenu = () => {
  const isSearchItem = document.querySelector('.mdn-Menu-top-list-item-search')
  const bodyElement = document.querySelector('body')

  closeAllMenus()
  menuToggleClass(bodyElement, 'add', 'mdn-Menu-top-isActive')
  menuToggleClass(isSearchItem, 'add', 'mdn-isActive')
  menuClickOutSide('add', effectToggleSubMenuSearch)
}
